<template>
  <!--    <Loader v-if="!$store.getters['global/isLoaded']"/>-->
  <!--    <div v-else>-->
  <!--    -->
  <div>
    <login-roll-back />
    <router-view />
     <set-address-profile v-if="shouldShowAddressPopup"
      v-model="showAddressPopup" 
      @success="onAddressSuccess" 
    />
  </div>
</template>

<style lang="scss">
// 3rd party plugins css
@import "~bootstrap-vue/dist/bootstrap-vue.css";
@import "~perfect-scrollbar/css/perfect-scrollbar.css";
@import "~socicon/css/socicon.css";
@import "~animate.css";
@import "~@fortawesome/fontawesome-free/css/all.css";
@import "~line-awesome/dist/line-awesome/css/line-awesome.css";
@import "assets/plugins/flaticon/flaticon.css";
@import "assets/plugins/flaticon2/flaticon.css";
@import "assets/plugins/keenthemes-icons/font/ki.css";
@import "assets/css/custom.css";
@import "assets/css/btnStyle.css";

// Main demo style scss
@import "assets/css/style.vue.rtl";

// Check documentation for RTL css
// Update HTML with RTL attribute at public/index.html

/*@import "assets/css/style.vue.rtl";*/
</style>

<script>
import { OVERRIDE_LAYOUT_CONFIG } from "@/core/services/store/config.module";
import Loader from "@/view/content/PreLoader.vue";
import LoginRollBack from "@/view/content/LoginRollBack";
import setAddressProfile from "./core/plugins/TitleRibbon/setAddressProfile.vue";

import "bootstrap";

export default {
  name: "MetronicVue",
  components: { Loader, LoginRollBack, setAddressProfile },
  data(){
    return{
      showAddressPopup: false,
    }
  },
    computed: {
    shouldShowAddressPopup() {
      try {
        const userInfo = localStorage.getItem("userInfo");
        if (!userInfo) return false; 
        
        const parsedUser = JSON.parse(userInfo);
        return parsedUser && Number(parsedUser.id) !== 75;
      } catch (e) {
        return false;
      }
    }
  },
  methods:{
     onAddressSuccess() {
      console.log("آدرس با موفقیت ثبت شد");
    }
  },
  mounted() {
    /**
     * this is to override the layout config using saved data from localStorage
     * remove this to use config only from static json (@/core/config/layout.config.json)
     */
    this.$on("offline", () => {
      this.$toast.error("شما به اینترنت متصل نیستید", {
        timeout: 5000,
      });
    });
    this.$root.$on("open-address-popup", () => {
      this.showAddressPopup = true;
    });
    this.$store.dispatch(OVERRIDE_LAYOUT_CONFIG);
    // this.requestApiGet('abilitiesType').then(response => {
    //   this.$ability.update([
    //     { subject: 'all', actions: response.data}
    //   ])
    // })
    
  },
  
  beforeDestroy() {
    this.$root.$off("open-address-popup");
  },
};
</script>
